var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 24,
    viewBox: "0 0 122 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_740_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6436 6.42285C30.4086 6.42285 31.9206 6.76062 33.1787 7.43652C34.4556 8.11253 35.4323 9.07981 36.1084 10.3379C36.7844 11.596 37.123 13.0984 37.123 14.8447V16.4229H24.3057C24.4935 17.6809 24.9724 18.6387 25.7422 19.2959C26.5121 19.9532 27.5269 20.2822 28.7852 20.2822C29.7803 20.2822 30.5693 20.1124 31.1514 19.7744C31.7333 19.4364 32.1465 18.9202 32.3906 18.2256H37.0664C36.6908 20.0283 35.7799 21.4457 34.334 22.4785C32.888 23.4926 31.0472 24 28.8125 24C26.9912 23.9999 25.4047 23.6431 24.0527 22.9297C22.7007 22.1973 21.6582 21.1738 20.9258 19.8594C20.1934 18.5261 19.8272 16.958 19.8271 15.1553C19.8271 13.3525 20.1838 11.8026 20.8975 10.5068C21.611 9.19247 22.6251 8.18796 23.9395 7.49316C25.2727 6.7796 26.8409 6.4229 28.6436 6.42285ZM28.6719 10.1123C27.5265 10.1123 26.5878 10.3852 25.8555 10.9297C25.1419 11.4743 24.6631 12.2726 24.4189 13.3242H32.6436C32.4933 12.2538 32.0804 11.4555 31.4043 10.9297C30.7282 10.3851 29.8174 10.1123 28.6719 10.1123Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8037 6.42285C72.0381 6.4229 73.8783 6.98581 75.3242 8.1123C76.7702 9.23907 77.6811 10.7889 78.0566 12.7607H73.3525C73.1084 12.0283 72.6859 11.4647 72.085 11.0703C71.4841 10.6761 70.7237 10.4786 69.8037 10.4785C68.5455 10.4785 67.5307 10.8925 66.7607 11.7188C66.0099 12.5449 65.6348 13.709 65.6348 15.2109C65.6348 16.7131 66.0193 17.8778 66.7891 18.7041C67.559 19.5304 68.5643 19.9434 69.8037 19.9434C71.7942 19.9433 73.0056 19.0983 73.4375 17.4082H78.1416C77.8036 19.4739 76.9118 21.0896 75.4658 22.2539C74.0199 23.4182 72.1322 24 69.8037 24C68.0384 24 66.4886 23.6433 65.1553 22.9297C63.8408 22.1973 62.8078 21.1739 62.0566 19.8594C61.3242 18.5448 60.958 16.995 60.958 15.2109C60.9581 13.4271 61.3244 11.8779 62.0566 10.5635C62.789 9.24903 63.8221 8.23509 65.1553 7.52148C66.4886 6.78909 68.0384 6.42285 69.8037 6.42285Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8447 0.844727C13.4175 0.844727 15.4175 1.49332 16.8447 2.78906C18.2719 4.08476 18.9862 5.85897 18.9863 8.1123C18.9863 10.3471 18.272 12.122 16.8447 13.4365C15.4175 14.7322 13.4174 15.3799 10.8447 15.3799H4.76074V23.6621H0V0.844727H10.8447ZM4.76074 11.2393H10.5635C11.7464 11.2392 12.6479 10.9673 13.2676 10.4229C13.8873 9.85947 14.1973 9.08883 14.1973 8.1123C14.1972 7.11719 13.8872 6.34727 13.2676 5.80273C12.6479 5.25819 11.7465 4.98634 10.5635 4.98633H4.76074V11.2393Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.917 6.45117C53.2643 6.45122 55.0766 7.0988 56.3535 8.39453C57.6492 9.67152 58.2969 11.3902 58.2969 13.5498V23.6621H53.6211V14.4229C53.6211 13.1834 53.2825 12.244 52.6064 11.6055C51.9492 10.9484 50.9819 10.6201 49.7051 10.6201C48.4285 10.6202 47.4523 10.9485 46.7764 11.6055C46.1191 12.244 45.79 13.1834 45.79 14.4229V23.6621H41.1143L41.1133 10.2461H38.873V6.76074H43.5361V9.52148H44.7197C45.377 8.545 46.203 7.7934 47.1982 7.26758C48.1936 6.72298 49.4334 6.45117 50.917 6.45117Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8594 23.6621H80.2109V6.97168H84.8594V23.6621Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5186 23.6621H88.8428V0H93.5186V23.6621Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8594 3.48633H80.2109V0H84.8594V3.48633Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.964 14.2311H122.164L112.564 23.8311L102.964 14.2311Z",
    fill: "url(#paint0_linear_740_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.764 19.0311H117.364L112.564 23.8311L107.764 19.0311Z",
    fill: "url(#paint1_linear_740_285)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.964,
    y: -0.168945,
    width: 19.2,
    height: 14.4,
    fill: "url(#paint2_linear_740_285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_285",
    x1: 102.964,
    y1: 23.8311,
    x2: 122.164,
    y2: 14.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_285",
    x1: 117.364,
    y1: 19.0311,
    x2: 107.764,
    y2: 23.8311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_285",
    x1: 102.964,
    y1: 14.2311,
    x2: 122.164,
    y2: -0.168946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_740_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.c073604f853f1b44e29289f7fc0dbd5d.svg";
export { ForwardRef as ReactComponent };